import { FilterName } from '@jetshop/ui/Filter/FilterAccordion';
import RangeFilter from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilter';
import RangeFiltersBehaviour from '@jetshop/ui/Filter/FilterTypes/Range/RangeFiltersBehaviour';
import React from 'react';
const RangeFilterAccordion = ({ rangeFilters, accordionProps, onSubmit = () => { }, startingIdx = 0 }) => {
    const { AccordionContent } = accordionProps;
    return (React.createElement(React.Fragment, null, rangeFilters.map((filter, idx) => (React.createElement(React.Fragment, { key: filter.id },
        React.createElement(FilterName, { accordionProps: accordionProps, idx: idx + startingIdx, filter: filter }),
        React.createElement(AccordionContent, { isOpen: accordionProps.openIndexes.includes(idx + startingIdx) },
            React.createElement(RangeFiltersBehaviour, { filters: rangeFilters }, ({ selectedVals, filterProps: { applyRangeFilter }, filter }) => {
                return (React.createElement(RangeFilter, { onSubmit: onSubmit, applyRangeFilter: applyRangeFilter, defaultVal: selectedVals, min: filter.min, max: filter.max, id: filter.id, key: filter.min + filter.max }));
            })))))));
};
export default RangeFilterAccordion;
//# sourceMappingURL=RangeFilterAccordion.js.map